import HowToBlock from './views/HowToBlock.c';
export default HowToBlock;
